import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=71f99e15&scoped=true"
import script from "./courseItem.vue?vue&type=script&lang=js"
export * from "./courseItem.vue?vue&type=script&lang=js"
import style0 from "./courseItem.vue?vue&type=style&index=0&id=71f99e15&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f99e15",
  null
  
)

export default component.exports